export default function ByTheNumbers() {
  const stats = [
    { number: '20+', label: 'Years Experience' },
    { number: '3,600+', label: 'Units Built or Renovated' },
    { number: '$225M+', label: 'in Completed Contract Work' },
    { number: '7', label: 'States Served' },
  ];

  return (
    <section className="py-20 bg-[#2C2C2C]">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-4xl font-bold text-white mb-16 text-center">
          By the Numbers
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-5xl md:text-6xl font-bold text-[#C5A55A] mb-3">
                {stat.number}
              </div>
              <div className="text-lg text-gray-300">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}